"use strict";

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.abbreviatePlural = exports.DATE_FORMATS = void 0;

var feature_utils_1 = require("@thesisedu/feature-utils");

var pluralize_1 = __importDefault(require("pluralize"));

exports.DATE_FORMATS = {
  FULL: 'MMMM D, YYYY [at] h:mm a',
  TEXT: 'MM/DD/YYYY h:mm A',
  TEXT_SHORT: 'MM/DD/YYYY',
  DATE: 'MMMM D, YYYY',
  MONTH_DAY: 'MMMM D',
  MONTH_DAY_SHORT: 'MMM D',
  TIME: 'h:mm a'
};
var ABBREVIATE_THRESHOLD = 1000;

var abbreviatePlural = function abbreviatePlural(word, number) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      showWord = _ref.showWord,
      _ref$threshold = _ref.threshold,
      threshold = _ref$threshold === void 0 ? ABBREVIATE_THRESHOLD : _ref$threshold;

  if (number >= threshold) {
    if (showWord) {
      return "".concat(feature_utils_1.Format.number(number, 'abbreviated'), " ").concat(pluralize_1["default"].plural(word));
    } else {
      return number.toString();
    }
  } else {
    if (showWord) {
      return (0, pluralize_1["default"])(word, number, true);
    } else {
      return number.toString();
    }
  }
};

exports.abbreviatePlural = abbreviatePlural;